export default function ChevronsRightIcon({ className, variant }: { className?: string; variant?: number }) {
  if (variant === 4) {
    return (
      <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none">
        <g clip-path="url(#clip0_1998_294)">
          <path
            d="M4.6665 4.66699L7.99984 8.00033L4.6665 11.3337"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8.6665 4.66699L11.9998 8.00033L8.6665 11.3337"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1998_294">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }
  if (variant === 3) {
    return (
      <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none">
        <g clip-path="url(#clip0_38757_6122)">
          <path
            d="M7 7L12 12L7 17"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M13 7L18 12L13 17"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_38757_6122">
            <rect width="24" height="24" fill="currentColor" />
          </clipPath>
        </defs>
      </svg>
    );
  }
  if (variant === 2) {
    return (
      <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none">
        <path
          d="M5.1665 4.66675L8.49984 8.00008L5.1665 11.3334M9.1665 4.66675L12.4998 8.00008L9.1665 11.3334"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  }
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none">
      <path
        d="M5.83398 5.8335L10.0007 10.0002L5.83398 14.1668M10.834 5.8335L15.0007 10.0002L10.834 14.1668"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
